/**
 *
 * Asynchronously loads the component for LocationList Page
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SubLocationListPage = lazyLoad(
  () => import('./index'),
  module => module.SubLocationListPage,
);
